import { useEffect, useCallback } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '1604085974259940'

let pixelLoaded = false

function loadPixelScript() {
  if (pixelLoaded) return
  pixelLoaded = true

  const f = window as any
  const b = document
  const n = (f.fbq = function (...args: any[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  })
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as any[]

  const t = b.createElement('script') as HTMLScriptElement
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  b.head.appendChild(t)
}

export function useMetaPixel() {
  useEffect(() => {
    loadPixelScript()
    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
  }, [])

  const trackAddToCart = useCallback(() => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: "The Grandparent's Smartphone Survival Guide",
        content_type: 'product',
        value: 6.39,
        currency: 'USD',
      })
    }
  }, [])

  return { trackAddToCart }
}
